import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.every.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React from 'react';
import { Button } from '../button/button.js';
import { Divider } from '../divider/divider.js';
import { Dropdown } from '../dropdown/dropdown.js';
import { Tooltip } from '../tooltip/tooltip.js';

var getUniqueKeyCounter = function getUniqueKeyCounter() {
  var counter = 0;
  return function () {
    counter += 1;
    return counter;
  };
};
/**
 * To be used when you want to display a tool bar of actions you can do to a certain area.
 * Disclaimer: This component is still under development
 */
var ToolBar = function ToolBar(_a) {
  var buttonGroups = _a.buttonGroups,
    _a$direction = _a.direction,
    direction = _a$direction === undefined ? 'vertical' : _a$direction,
    className = _a.className,
    children = _a.children,
    _a$elevation = _a.elevation,
    elevation = _a$elevation === undefined ? 'z-4' : _a$elevation,
    rest = __rest(_a, ["buttonGroups", "direction", "className", "children", "elevation"]);
  var getUniqueKey = getUniqueKeyCounter();
  var classNames = ['cogs-v10', 'cogs-toolbar', "cogs-toolbar-" + direction, elevation, className].filter(Boolean).join(' ');
  return jsx("div", Object.assign({
    className: classNames
  }, rest, {
    children: (buttonGroups || []
    // skip button groups where all button in the group is marked as hidden.
    ).filter(function (buttonGroup) {
      return !buttonGroup.every(function (button) {
        return button.hide;
      });
    }).map(function (buttonGroup) {
      return jsx(ButtonGroup, {
        buttonGroup: buttonGroup
      }, "toolbar-buttongroup-" + getUniqueKey());
    }).concat(React.Children.toArray(children)).map(function (el, index, array) {
      if (index === array.length - 1) {
        return el;
      }
      return jsxs(React.Fragment, {
        children: [el, jsx(Divider, {
          direction: direction === 'vertical' ? 'horizontal' : 'vertical',
          length: "16px",
          endcap: "round",
          spacing: "8px",
          style: {
            '--Divider-spacing': '4px'
          },
          weight: "1px"
        })]
      }, "toolbar-buttongroup-fragment-" + getUniqueKey());
    })
  }), "toolbar-component-" + getUniqueKey());
};
var ButtonGroup = function ButtonGroup(_ref) {
  var buttonGroup = _ref.buttonGroup;
  var getUniqueKey = getUniqueKeyCounter();
  var getButtonWithOrWithoutDropdown = function getButtonWithOrWithoutDropdown(_a, buttonIndex) {
    var dropdownContent = _a.dropdownContent,
      dropdownProps = _a.dropdownProps,
      icon = _a.icon,
      onClick = _a.onClick,
      text = _a.text,
      description = _a.description,
      disabled = _a.disabled,
      buttonRest = __rest(_a, ["dropdownContent", "dropdownProps", "icon", "onClick", "text", "description", "disabled"]);
    var key = text + "-" + buttonIndex + "-" + getUniqueKey();
    if (dropdownContent) {
      return jsx("div", {
        className: "cogs-v10 cogs-toolbar__dropdown-container",
        children: jsx(Dropdown, Object.assign({
          content: dropdownContent
        }, dropdownProps, {
          children: jsx(Button, Object.assign({
            type: "ghost",
            icon: icon,
            onClick: onClick,
            "aria-label": text || description,
            disabled: disabled
          }, buttonRest, {
            "aria-hidden": buttonRest['aria-hidden'] === 'true',
            className: "cogs-v10 cogs-toolbar__button",
            children: text
          }), "dropdown-button-" + key)
        }), "dropdown-" + key)
      });
    }
    return jsx(Button, Object.assign({
      type: "ghost",
      icon: icon,
      onClick: onClick,
      "aria-label": text || description,
      disabled: disabled
    }, buttonRest, {
      "aria-hidden": buttonRest['aria-hidden'] === 'true',
      className: "cogs-v10 cogs-toolbar__button",
      children: text
    }), "button-" + key);
  };
  return jsx(Fragment, {
    children: buttonGroup.map(function (button, buttonIndex) {
      if (button.hide) {
        return null;
      }
      if (button.description) {
        return jsx(Tooltip, {
          content: button.description,
          children: getButtonWithOrWithoutDropdown(button, buttonIndex + 1)
        }, "toolbar-tooltip-" + button.text + "-" + (buttonIndex + 1) + "-" + getUniqueKey());
      }
      return getButtonWithOrWithoutDropdown(button, buttonIndex + 1);
    })
  });
};
ToolBar.ButtonGroup = ButtonGroup;

export { ToolBar };
